export enum OpenAICallRestriction {
  TRIAL_TEACHER = 12,
  TEACHER_ONLY = 15,
}
export enum OpenAICredits {
  MONTHLY = 1000,
}

export enum SubscriptionPlanTypes {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  FREE = 'free',
}
